import {Grid, Typography} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {IoInformationCircleSharp} from 'react-icons/io5';
import {useNavigate, useParams} from 'react-router-dom';
import {Modal} from '../../components/modal/modal';
import {useAddepar} from '../../hooks/use-adepar';
import {useAuth} from '../../hooks/use-auth';
import {useBill} from '../../hooks/use-bill';
import {useBridge} from '../../hooks/use-bridge';
import {usePlaid} from '../../hooks/use-plaid';
import '../../styles/plaid.css';

const UserAccounts = ({user}) => {
  const {id, type} = useParams();
  const navigate = useNavigate();
  const {
    state: {users},
    deleteUser,
  } = useAuth();
  const {
    state: {all_accounts, user_accounts, user_institutions, all_institutions},
    getUserAccounts,
    getUserInstitutions,
    removeUserInstitutions,
  } = usePlaid();
  const {
    state: {user_connections, connections},
    getUserConnections,
    removeUserConnections,
  } = useBill();
  const {
    state: {
      user_connections: addepar_user_connections,
      connections: addepar_connections,
    },
    getUserConnections: getAddeparConnections,
    removeUserConnections: removeAddeparConnections,
  } = useAddepar();
  const {
    state: {
      user_connections: bridge_user_connections,
      connections: bridge_connections,
    },
    getUserConnections: getUserBridgeConnections,
    removeUserConnections: removeUserBridgeConnections,
  } = useBridge();

  const [info, setInfo] = useState(false);

  const profile = users?.[id] ?? {};
  const {fullName, customerID, emailAddress} = profile;

  const accounts = user_accounts?.[id] ?? [];
  const cons = user_connections?.[id] ?? [];
  const addepar_cons = addepar_user_connections?.[id] ?? [];
  const bridge_cons = bridge_user_connections?.[id] ?? [];

  useEffect(() => {
    if (id && user_accounts?.[id] === undefined) {
      getUserAccounts(id);
    }
    if (id && user_institutions?.[id] === undefined) {
      getUserInstitutions(id);
    }
    if (id && user_connections[id] === undefined) {
      getUserConnections(id);
    }
    if (id && addepar_user_connections?.[id] === undefined) {
      getAddeparConnections(id);
    }
    if (id && bridge_user_connections?.[id] === undefined) {
      getUserBridgeConnections(id);
    }
  }, []);

  return (
    <div className="page-container">
      <div className="flex-row justify-between align-center">
        <p style={{fontWeight: 'bold', fontSize: '24px'}}>
          User: {emailAddress} - {type}
        </p>
        <button
          className="gray-button"
          onClick={() => {
            navigate(-1);
          }}>
          Done
        </button>
      </div>
      <div className="flex-row justify-between">
        <table>
          {(type === 'plaid' || type === 'bill') && (
            <thead>
              <tr>
                <th>Institution</th>
                <th>Entity</th>
                <th>Account Name</th>
                <th>Account Type</th>
                <th>Account Number Ending</th>
                <th>Status</th>
              </tr>
            </thead>
          )}
          {type === 'addepar' && (
            <thead>
              <tr>
                <th>Institution</th>
                <th>Entity Name</th>
                <th>Account Name</th>
                <th>Owner Id</th>
                <th>Entity Id</th>
                <th>Status</th>
              </tr>
            </thead>
          )}
          {type === 'bridgeft' && (
            <thead>
              <tr>
                <th>Institution</th>
                <th>Custodian</th>
                <th>Entity</th>
                <th>Account Type</th>
                <th>Account Name</th>
                <th>Status</th>
              </tr>
            </thead>
          )}
          <tbody>
            {type === 'plaid' &&
              accounts.map(id => {
                const {
                  name,
                  subtype,
                  mask,
                  disable,
                  entity,
                  error,
                  access_token,
                } = all_accounts[id];
                const inst = all_institutions?.[access_token] ?? {};
                const {name: inst_name} = inst;

                return (
                  <tr key={id}>
                    <td>{inst_name}</td>
                    <td>{entity}</td>
                    <td>{name}</td>
                    <td>{subtype}</td>
                    <td>{mask}</td>
                    <td>{error || 'Active'}</td>
                  </tr>
                );
              })}
            {type === 'bill' &&
              cons.map(id => {
                const connection = connections?.[id] ?? {};
                const {organizations} = connection;

                return organizations?.map(org => {
                  const {orgName} = org;
                  return (
                    <tr key={id}>
                      <td>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}>
                          Bill.com
                          <IoInformationCircleSharp
                            onClick={() => {
                              setInfo(connection);
                            }}
                            style={{marginLeft: '8px', cursor: 'pointer'}}
                            size={'20px'}
                          />
                        </div>
                      </td>
                      <td>{orgName}</td>
                      <td>{'Forest Account'}</td>
                      <td>-</td>
                      <td>-</td>
                      <td>{'Active'}</td>
                    </tr>
                  );
                });
              })}
            {type === 'addepar' &&
              addepar_cons?.map(id => {
                const connection = addepar_connections?.[id] ?? {};
                const {account_mappings} = connection;

                return account_mappings?.map(mapping => {
                  const {account_name, entity_id, entity_name, owner_id} =
                    mapping;
                  return (
                    <tr key={entity_id}>
                      <td>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}>
                          Addepar
                        </div>
                      </td>
                      <td>{entity_name}</td>
                      <td>{account_name}</td>
                      <td>{owner_id}</td>
                      <td>{entity_id}</td>
                      <td>{'Active'}</td>
                    </tr>
                  );
                });
              })}
            {type === 'bridgeft' &&
              bridge_cons.map(id => {
                const connection = bridge_connections?.[id] ?? {};
                const {account_mappings} = connection;

                return account_mappings?.map(mapping => {
                  const {custodian, entity, acct_type, display_name, ignore} =
                    mapping;
                  return (
                    <tr key={id}>
                      <td>Addepar</td>
                      <td>{custodian}</td>
                      <td>{entity}</td>
                      <td>{acct_type}</td>
                      <td>{display_name}</td>
                      <td>{ignore ? 'Ingored' : 'Active'}</td>
                    </tr>
                  );
                });
              })}
          </tbody>
        </table>
        <div>
          <button
            className="gray-button"
            onClick={async () => {
              if (
                window.confirm(
                  'Are you sure you want to delete this user? This disconnects all accounts related to the user',
                )
              ) {
                // Proceed with delete operation of accounts and connections
                console.log('Item deleted');

                // DELETE PLAID OBJECTS
                const access_tokens = user_institutions[id];
                await removeUserInstitutions(id, access_tokens);
                // DELETE BILL OBJECTS
                const connection_ids = user_connections[id];
                await removeUserConnections(id, connection_ids);
                // DELETE ADDEPAR OBJECTS
                const addepar_connection_ids = addepar_user_connections[id];
                await removeAddeparConnections(id, addepar_connection_ids);
                // DELETE BRIDGEFT OBJECTS
                const bridgeft_connection_ids =
                  bridge_user_connections[id] || [];
                const bridgeft_connections_to_remove =
                  bridgeft_connection_ids.map(
                    con_id => bridge_connections[con_id],
                  );
                await removeUserBridgeConnections(
                  id,
                  bridgeft_connections_to_remove,
                );
                navigate(-1);
              } else {
                // Cancel delete operation
                console.log('Delete cancelled');
              }
            }}>
            Disconnect All Accounts
          </button>
        </div>
      </div>
      <br />
      <br />
      <BillInfoModal info={info} setInfo={setInfo} />
    </div>
  );
};

export const BillInfoModal = ({info, setInfo}) => {
  if (!info) return null;

  const {
    credit_memo,
    company,
    vendor_credits,
    error,
    userName,
    accounts_payable,
    accounts_receivable,
    organizations,
  } = info;

  return (
    <Modal active={!!info} setActive={setInfo}>
      <div className="box flex-column" style={{padding: '20px'}}>
        <Typography variant="h5" sx={{mb: 3, fontWeight: 'bold'}}>
          {userName}
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Display field="Company" value={company} />
            <Display field="Credit Memo" value={credit_memo} />
            <Display field="Vendor Credits" value={vendor_credits} />
          </Grid>
          <Grid item xs={6}>
            <Display field="Error" value={error || 'None'} />
            <Display field="Accounts Payable" value={accounts_payable} />
            <Display field="Accounts Receivable" value={accounts_receivable} />
          </Grid>
        </Grid>

        <Typography variant="h6">Organizations</Typography>
        <ul style={{listStyle: 'none', padding: 0}}>
          {organizations?.map((org, index) => (
            <li key={index}>
              <Typography sx={{marginLeft: '8px'}}>{org.orgName}</Typography>
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  );
};

const Display = ({field, value}) => {
  return (
    <div style={{marginBottom: '12px'}}>
      <Typography variant="subtitle2" color="text.secondary">
        {field}
      </Typography>
      <Typography variant="body1">{value}</Typography>
    </div>
  );
};

export default UserAccounts;
